var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaperAirplane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_568_2390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8501 8.7382C10.5017 8.58976 10.0992 8.65094 9.8106 8.89623C9.52199 9.14153 9.39674 9.52884 9.48707 9.89668L13.2199 25.0975C13.3144 25.4827 13.6277 25.7755 14.0183 25.844C14.4089 25.9125 14.8031 25.7438 15.023 25.4138L17.9077 21.0872C18.1554 20.7157 18.1268 20.2251 17.8377 19.8849L14.8771 16.4016C14.5195 15.9808 14.5707 15.3497 14.9915 14.992C15.4123 14.6343 16.0434 14.6855 16.4011 15.1064L19.3616 18.5896C19.6507 18.9298 20.1304 19.0371 20.5369 18.8526L25.272 16.703C25.6331 16.5391 25.8632 16.1773 25.8585 15.7808C25.8539 15.3842 25.6153 15.0279 25.2505 14.8725L10.8501 8.7382Z",
    fill: "#1C2569"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_568_2390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.895508 13.8486) rotate(-40.3619)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperAirplane);
export default __webpack_public_path__ + "static/media/paper-airplane.4d8fd7316e6714fd379bf0b46fb97559.svg";
export { ForwardRef as ReactComponent };